(function () {
  'use strict';

  const sections = document.querySelectorAll('[id^="pantograph-preview-tool-"]');

  sections.forEach(function (root) {
    /**
     * Elements
     */
    const canvas = root.querySelector('[data-ppt-canvas]');
    const previewColumn = root.querySelector('[data-ppt-preview-column]') || root.querySelector('.ppt-preview-column');
    const controlsColumn = root.querySelector('[data-ppt-controls-column]') || root.querySelector('.ppt-controls-column');
    const stickyPreviewColumn = root.querySelector('[data-ppt-sticky-preview]') || previewColumn;
    const mobileControlsColumn = root.querySelector('[data-ppt-scroll-controls]') || controlsColumn;

    const previewZoomInput = root.querySelector('[data-ppt-preview-zoom]');
    const previewZoomOutput = root.querySelector('[data-ppt-preview-zoom-output]');
    const previewZoomMinus = root.querySelector('[data-ppt-preview-zoom-minus]');
    const previewZoomPlus = root.querySelector('[data-ppt-preview-zoom-plus]');

    const colorPresetButtons = root.querySelectorAll('[data-ppt-color-preset]');
    const quiltInput = root.querySelector('[data-ppt-quilt-input]');
    const uploadBox = root.querySelector('[data-ppt-upload-box]');
    const quiltImg = root.querySelector('[data-ppt-quilt-img]');
    const svgLayer = root.querySelector('[data-ppt-svg-layer]');
    const emptyState = root.querySelector('[data-ppt-empty-state]');
    const overlayTab = root.querySelector('[data-ppt-overlay-tab]');
    const originalTab = root.querySelector('[data-ppt-original-tab]');
    const resetViewButtons = root.querySelectorAll('[data-ppt-reset-view]');

    const quiltWidthInput = root.querySelector('[data-ppt-quilt-width]');
    const quiltHeightInput = root.querySelector('[data-ppt-quilt-height]');
    const pantographSearch = root.querySelector('[data-ppt-search]');
    const pantographSelect = root.querySelector('[data-ppt-select]');

    const scaleInput = root.querySelector('[data-ppt-scale]');
    const scaleNumberInput = root.querySelector('[data-ppt-scale-number]');
    const positionXInput = root.querySelector('[data-ppt-position-x]');
    const positionXNumberInput = root.querySelector('[data-ppt-position-x-number]');
    const positionYInput = root.querySelector('[data-ppt-position-y]');
    const positionYNumberInput = root.querySelector('[data-ppt-position-y-number]');
    const rotationButtons = root.querySelectorAll('[data-ppt-rotation-option]');
    const strokeInput = root.querySelector('[data-ppt-stroke]');
    const strokeNumberInput = root.querySelector('[data-ppt-stroke-number]');
    const colorInput = root.querySelector('[data-ppt-color]');
    const hexInput = root.querySelector('[data-ppt-color-hex]');
    const opacityInput = root.querySelector('[data-ppt-opacity]');
    const opacityNumberInput = root.querySelector('[data-ppt-opacity-number]');

    const scaleOutput = root.querySelector('[data-ppt-scale-output]');
    const positionXOutput = root.querySelector('[data-ppt-position-x-output]');
    const positionYOutput = root.querySelector('[data-ppt-position-y-output]');
    const rotationOutput = root.querySelector('[data-ppt-rotation-output]');
    const strokeOutput = root.querySelector('[data-ppt-stroke-output]');
    const colorOutput = root.querySelector('[data-ppt-color-output]');
    const opacityOutput = root.querySelector('[data-ppt-opacity-output]');

    const settingsTextarea = root.querySelector('[data-ppt-settings-text]');
    const downloadBtn = root.querySelector('[data-ppt-download]');
    const buyBtn = root.querySelector('[data-ppt-buy]');
    const copySettingsBtn = root.querySelector('[data-ppt-copy-settings]');
    const downloadSettingsBtn = root.querySelector('[data-ppt-download-settings]');

    const maxRowInput = root.querySelector('[data-ppt-max-row]');
    const resultScale = root.querySelector('[data-ppt-result-scale]');
    const resultHeight = root.querySelector('[data-ppt-result-height]');
    const resultGap = root.querySelector('[data-ppt-result-gap]');
    const resultCheck = root.querySelector('[data-ppt-result-check]');
    const warning = root.querySelector('[data-ppt-warning]');
    const setupTheme = root.querySelector('[data-ppt-setup-theme]');
    const setupDesigner = root.querySelector('[data-ppt-setup-designer]');
    const setupPrecision = root.querySelector('[data-ppt-setup-precision]');
    const setupOffset = root.querySelector('[data-ppt-setup-offset]');
    const setupBacktracking = root.querySelector('[data-ppt-setup-backtracking]');
    const setupDefaultHeight = root.querySelector('[data-ppt-setup-default-height]');
    const setupDefaultGap = root.querySelector('[data-ppt-setup-default-gap]');

    const featuredTrack = root.querySelector('[data-ppt-featured-track]') || root.querySelector('.ppt-product-row');
    const featuredPrev = root.querySelector('[data-ppt-featured-prev]');
    const featuredNext = root.querySelector('[data-ppt-featured-next]');
    const featuredStatus = root.querySelector('[data-ppt-featured-status]');
    const featuredSearch = root.querySelector('[data-ppt-featured-search]');
    const featuredFilter = root.querySelector('[data-ppt-featured-filter]');

    /**
     * Constants and state
     */
    const FALLBACK_QUILT_WIDTH = 72;
    const FALLBACK_QUILT_HEIGHT = 84;
    const DEFAULT_SIDE_CROP_ASPECT = 10;

    // Move values are stored in a fixed 1000 x 1000 quilt coordinate system.
    // This keeps placement identical on desktop, tablet, mobile, and export.
    const POSITION_REFERENCE_WIDTH = 1000;
    const POSITION_REFERENCE_HEIGHT = 1000;

    // A 500 px reference keeps the visible stroke close to the current UI size,
    // while allowing the exported stroke to scale proportionally with the image.
    const STROKE_REFERENCE_SIZE = 500;

    const FEATURED_BATCH_SIZE = 32;

    // Temporary preview persistence. This is intentionally separate from the
    // existing favorites storage and expires after approximately one minute.
    const PREVIEW_STORAGE_KEY = 'ppt_preview_state_v1';
    const PREVIEW_STORAGE_TTL = 5 * 60 * 1000;
    let isRestoringPreviewState = false;
    let pendingPreviewState = null;

    let svgElement = null;
    let quiltLoaded = false;
    let svgLoaded = false;
    let selectedPantograph = null;
    let selectedProductUrl = '';
    let selectedProductTitle = '';
    let selectedSvgUrl = '';
    let manualCalculatedHeight = null;
    let viewMode = 'overlay';

    let isPreviewDragging = false;
    let previewDragStartX = 0;
    let previewDragStartY = 0;
    let previewDragStartPanX = 0;
    let previewDragStartPanY = 0;

    let allPantographs = [];
    let catalogTotalProducts = 0;
    let catalogComplete = false;
    let featuredRenderedCount = 0;
    let featuredItems = [];
    let searchIndex = [];
    let catalogIndexReady = false;
    let featuredSearchTimer = null;

    const defaultState = {
      scale: 100,
      previewZoom: 100,
      previewPanX: 0,
      previewPanY: 0,
      moveX: 0,
      moveY: 0,
      rotation: 0,
      strokeWidth: 0.75,
      strokeColor: '#000000',
      opacity: 85
    };

    const state = Object.assign({}, defaultState);

    /* =========================================================
   Preview Tool Active User Tracking
   ========================================================= */

    const SUPABASE_URL = 'https://jokxzipujcamzepzysji.supabase.co';
    const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_ddkt-p-da5Ik9u31Ps_JvQ_9pN47NCE';

    const PREVIEW_SESSION_KEY = 'ppt_preview_active_session_id';

    function getPreviewSessionId() {
      let sessionId = sessionStorage.getItem(PREVIEW_SESSION_KEY);

      if (!sessionId) {
        sessionId =
          'ppt_' +
          Date.now().toString(36) +
          '_' +
          Math.random().toString(36).slice(2) +
          '_' +
          Math.random().toString(36).slice(2);

        sessionStorage.setItem(PREVIEW_SESSION_KEY, sessionId);
      }

      return sessionId;
    }

    async function updatePreviewActiveSession() {
      try {
        const response = await fetch(
          SUPABASE_URL + '/rest/v1/rpc/record_preview_session',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'apikey': SUPABASE_PUBLISHABLE_KEY,
              'Authorization': 'Bearer ' + SUPABASE_PUBLISHABLE_KEY
            },
            body: JSON.stringify({
              p_session_id: getPreviewSessionId(),
              p_page: window.location.pathname
            })
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Preview user tracking failed:', response.status, errorText);
        } else {
          console.log('Preview user tracking: session updated successfully');
        }
      } catch (error) {
        console.warn('Preview user tracking error:', error);
      }
    }

    updatePreviewActiveSession();

    setInterval(updatePreviewActiveSession, 30000);


        /* =========================================================
       Preview Tool Live Active User Count
       ========================================================= */

      const activeUsersCount = root.querySelector('[data-ppt-active-users-count]');
      const activeUsersLabel = root.querySelector('[data-ppt-active-users-label]');

      async function updatePreviewActiveUserCount() {
        if (!activeUsersCount) return;

        try {
          const response = await fetch(
            SUPABASE_URL + '/rest/v1/rpc/get_active_preview_users',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'apikey': SUPABASE_PUBLISHABLE_KEY,
                'Authorization': 'Bearer ' + SUPABASE_PUBLISHABLE_KEY
              },
              body: JSON.stringify({})
            }
          );

          if (!response.ok) {
            throw new Error(
              'Active user count request failed: ' + response.status
            );
          }

          const count = parseInt(await response.json(), 10);

          if (!Number.isFinite(count)) {
            throw new Error('Invalid active user count');
          }

          activeUsersCount.textContent = count;

          if (activeUsersLabel) {
            activeUsersLabel.textContent =
              count === 1
                ? '🟢'
                : '🟢';
          }

        } catch (error) {
          console.warn('Preview active user count failed:', error);
        }
      }

      updatePreviewActiveUserCount();

      setInterval(updatePreviewActiveUserCount, 30000);

    /**
     * Temporary preview state persistence
     *
     * Favorites use their own existing storage mechanism. Do not reuse or
     * modify it here. This snapshot is only for the current browser session
     * and is automatically ignored/removed after one minute.
     */
    function getPreviewStorage() {
      try {
        return window.sessionStorage;
      } catch (error) {
        return null;
      }
    }

    function clearSavedPreviewState() {
      const storage = getPreviewStorage();
      if (!storage) return;

      try {
        storage.removeItem(PREVIEW_STORAGE_KEY);
      } catch (error) {
        // Storage can be unavailable/restricted. The preview itself should
        // continue working normally.
      }
    }

    function getPreviewStateSnapshot(includeImage) {
      const restoredImage = pendingPreviewState && pendingPreviewState.quiltImage
        ? pendingPreviewState.quiltImage
        : '';

      const snapshot = {
        version: 1,
        expiresAt: Date.now() + PREVIEW_STORAGE_TTL,
        state: Object.assign({}, state),
        viewMode: viewMode,
        selectedSvgUrl: selectedSvgUrl || '',
        selectedProductUrl: selectedProductUrl || '',
        selectedProductTitle: selectedProductTitle || '',
        quiltWidth: quiltWidthInput ? quiltWidthInput.value : '',
        quiltHeight: quiltHeightInput ? quiltHeightInput.value : '',
        maxRowHeight: maxRowInput ? maxRowInput.value : '',
        quiltImage: includeImage && quiltLoaded && quiltImg && quiltImg.src
          ? quiltImg.src
          : restoredImage
      };

      return snapshot;
    }

    function writePreviewSnapshot(snapshot) {
      const storage = getPreviewStorage();
      if (!storage || !snapshot) return false;

      try {
        storage.setItem(PREVIEW_STORAGE_KEY, JSON.stringify(snapshot));
        return true;
      } catch (error) {
        return false;
      }
    }

    function savePreviewState() {
      if (isRestoringPreviewState) return;

      const snapshot = getPreviewStateSnapshot(true);
      if (writePreviewSnapshot(snapshot)) return;

      // A large quilt image can exceed sessionStorage's quota. Preserve the
      // complete configuration even if the image itself cannot fit.
      snapshot.quiltImage = '';
      writePreviewSnapshot(snapshot);
    }

    function readSavedPreviewState() {
      const storage = getPreviewStorage();
      if (!storage) return null;

      try {
        const raw = storage.getItem(PREVIEW_STORAGE_KEY);
        if (!raw) return null;

        const snapshot = JSON.parse(raw);
        if (!snapshot || snapshot.version !== 1 || !Number.isFinite(snapshot.expiresAt)) {
          clearSavedPreviewState();
          return null;
        }

        if (snapshot.expiresAt <= Date.now()) {
          clearSavedPreviewState();
          return null;
        }

        if (!snapshot.state || typeof snapshot.state !== 'object') {
          clearSavedPreviewState();
          return null;
        }

        return snapshot;
      } catch (error) {
        clearSavedPreviewState();
        return null;
      }
    }

    function restorePreviewState() {
      const snapshot = readSavedPreviewState();
      if (!snapshot) return;

      isRestoringPreviewState = true;

      Object.keys(defaultState).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(snapshot.state, key)) {
          const value = snapshot.state[key];
          if (typeof value === 'number' && Number.isFinite(value)) {
            state[key] = value;
          } else if (key === 'strokeColor' && typeof value === 'string') {
            const color = sanitizeHex(value);
            if (color) state.strokeColor = color;
          }
        }
      });

      if (snapshot.viewMode === 'original' || snapshot.viewMode === 'overlay') {
        viewMode = snapshot.viewMode;
      }

      selectedSvgUrl = typeof snapshot.selectedSvgUrl === 'string' ? snapshot.selectedSvgUrl : '';
      selectedProductUrl = typeof snapshot.selectedProductUrl === 'string' ? snapshot.selectedProductUrl : '';
      selectedProductTitle = typeof snapshot.selectedProductTitle === 'string' ? snapshot.selectedProductTitle : '';

      if (quiltWidthInput && snapshot.quiltWidth !== undefined) {
        quiltWidthInput.value = snapshot.quiltWidth;
      }
      if (quiltHeightInput && snapshot.quiltHeight !== undefined) {
        quiltHeightInput.value = snapshot.quiltHeight;
      }
      if (maxRowInput && snapshot.maxRowHeight !== undefined) {
        maxRowInput.value = snapshot.maxRowHeight;
      }

      pendingPreviewState = snapshot;

      // File inputs cannot be restored by the browser, but the image data URL
      // can safely recreate the visible quilt image.
      if (snapshot.quiltImage && quiltImg) {
        quiltImg.onload = function () {
          if (quiltImg.naturalWidth && quiltImg.naturalHeight) {
            canvas.style.aspectRatio = quiltImg.naturalWidth + ' / ' + quiltImg.naturalHeight;
          }

          quiltImg.classList.add('is-visible');
          if (emptyState) emptyState.style.display = 'none';
          quiltLoaded = true;

          if (uploadBox) {
            uploadBox.classList.add('is-loaded');
            const title = uploadBox.querySelector('.ppt-upload-title');
            const small = uploadBox.querySelector('small');
            if (title) title.textContent = 'Photo Restored';
            if (small) small.textContent = 'Restored from this session';
          }

          isRestoringPreviewState = false;
          refreshPreview();
          savePreviewState();
        };

        quiltImg.src = snapshot.quiltImage;
      } else {
        isRestoringPreviewState = false;
      }
    }

    /**
     * Generic helpers
     */
    function clamp(value, min, max) {
      const number = parseFloat(value);
      if (!Number.isFinite(number)) return min;
      return Math.min(max, Math.max(min, number));
    }

    function parseNumber(value) {
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : null;
    }

    function parsePositiveNumber(value) {
      const parsed = parseNumber(value);
      return parsed !== null && parsed > 0 ? parsed : null;
    }

    function formatNumber(value, decimals) {
      if (!Number.isFinite(value)) return 'Not set';
      return Number(value)
        .toFixed(decimals)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1');
    }

    function formatInches(value) {
      return Number.isFinite(value) ? formatNumber(value, 2) + ' in' : 'Not set';
    }

    function sanitizeHex(value) {
      if (!value) return null;
      let hex = String(value).trim();
      if (hex.charAt(0) !== '#') hex = '#' + hex;
      return /^#[0-9a-fA-F]{6}$/.test(hex) ? hex.toUpperCase() : null;
    }

    function setInputValue(input, value) {
      if (input) input.value = value;
    }

    function getRangeMeta(input, fallbackMin, fallbackMax, fallbackStep) {
      return {
        min: input && Number.isFinite(parseFloat(input.min)) ? parseFloat(input.min) : fallbackMin,
        max: input && Number.isFinite(parseFloat(input.max)) ? parseFloat(input.max) : fallbackMax,
        step: input && Number.isFinite(parseFloat(input.step)) ? parseFloat(input.step) : fallbackStep
      };
    }

    function numberValue(input, fallback) {
      if (!input) return fallback;
      const value = parseFloat(input.value);
      return Number.isFinite(value) ? value : fallback;
    }

    function getInputPositiveNumber(input) {
      if (!input || String(input.value).trim() === '') return null;
      const value = parseFloat(input.value);
      return Number.isFinite(value) && value > 0 ? value : null;
    }

    function getQuiltWidthInches() {
      return getInputPositiveNumber(quiltWidthInput);
    }

    function getQuiltHeightInches() {
      return getInputPositiveNumber(quiltHeightInput);
    }

    function hasCompleteQuiltSize() {
      return getQuiltWidthInches() !== null && getQuiltHeightInches() !== null;
    }

    function getEffectiveQuiltWidthInches() {
      return hasCompleteQuiltSize() ? getQuiltWidthInches() : FALLBACK_QUILT_WIDTH;
    }

    function getEffectiveQuiltHeightInches() {
      return hasCompleteQuiltSize() ? getQuiltHeightInches() : FALLBACK_QUILT_HEIGHT;
    }

    function cleanCatalogText(value) {
      if (value === null || value === undefined) return '';

      if (Array.isArray(value)) {
        return value.map(cleanCatalogText).filter(Boolean).join(', ');
      }

      if (typeof value === 'object') {
        return Object.values(value).map(cleanCatalogText).filter(Boolean).join(', ');
      }

      let text = String(value).trim();
      if (!text) return '';

      const decoder = document.createElement('textarea');
      decoder.innerHTML = text;
      text = decoder.value.trim();

      const looksLikeJson =
        text.charAt(0) === '[' ||
        text.charAt(0) === '{' ||
        (text.charAt(0) === '"' && text.charAt(text.length - 1) === '"');

      if (looksLikeJson) {
        try {
          return cleanCatalogText(JSON.parse(text));
        } catch (error) {
          // It is already plain text.
        }
      }

      return text
        .replace(/^\[/, '')
        .replace(/\]$/, '')
        .replace(/^["']/, '')
        .replace(/["']$/, '')
        .trim();
    }

    function readCatalogNumber(value) {
      const text = cleanCatalogText(value)
        .replace(/inches/gi, '')
        .replace(/inch/gi, '')
        .replace(/in/gi, '')
        .replace(/"/g, '')
        .trim();

      const number = parseFloat(text);
      return Number.isFinite(number) ? number : null;
    }

    function extractHeightFromTags(tags) {
      const text = cleanCatalogText(tags);
      if (!text) return null;

      const match = text.match(/Pantograph Height\s*-?\s*([0-9]+(?:\.[0-9]+)?)/i);
      if (!match || !match[1]) return null;

      const value = parseFloat(match[1]);
      return Number.isFinite(value) ? value : null;
    }

    function getMaxSideCropAspect() {
      const value = parseFloat(root.getAttribute('data-ppt-max-side-aspect'));
      return Number.isFinite(value) && value > 0 ? value : DEFAULT_SIDE_CROP_ASPECT;
    }

    /**
     * Pantograph catalog loading
     *
     * Shopify limits collection.products in a normal section render. The Liquid
     * section now exposes one paginated JSON page at a time. This loader fetches
     * all remaining section pages and builds one catalog containing every SVG.
     */
    function normalizePantograph(item) {
      if (!item) return null;

      const svgUrl = cleanCatalogText(item.svgUrl || item.svg_url || item.url);
      if (!svgUrl) return null;

      const tags = cleanCatalogText(item.tags);
      const rawDefaultHeight = readCatalogNumber(item.defaultHeight);

      return {
        svgUrl: svgUrl,
        title: cleanCatalogText(item.title) || 'Untitled pantograph',
        productUrl: cleanCatalogText(item.productUrl),
        productId: cleanCatalogText(item.productId),
        svgIndex: parseInt(item.svgIndex, 10) || 1,
        imageUrl: cleanCatalogText(item.imageUrl),
        defaultHeight: rawDefaultHeight !== null ? rawDefaultHeight : extractHeightFromTags(tags),
        rowGap: readCatalogNumber(item.rowGap),
        previewWidth: readCatalogNumber(item.previewWidth) || 108,
        previewHeight: readCatalogNumber(item.previewHeight) || 108,
        maxHeight: readCatalogNumber(item.maxHeight),
        theme: cleanCatalogText(item.theme),
        designer: cleanCatalogText(item.designer),
        precision: cleanCatalogText(item.precision),
        offset: cleanCatalogText(item.offset),
        backtracking: cleanCatalogText(item.backtracking),
        tags: tags
      };
    }

    function readPantographPage(scope) {
      const dataNode = scope.querySelector('[data-ppt-pantograph-data]');

      if (!dataNode) {
        return {
          items: [],
          currentPage: 1,
          totalPages: 1,
          pageParam: 'page',
          totalProducts: 0
        };
      }

      let parsed = [];
      try {
        parsed = JSON.parse(dataNode.textContent || '[]');
      } catch (error) {
        console.error('Pantograph catalog JSON could not be parsed.', error);
      }

      return {
        items: Array.isArray(parsed) ? parsed.map(normalizePantograph).filter(Boolean) : [],
        currentPage: parseInt(dataNode.getAttribute('data-current-page'), 10) || 1,
        totalPages: parseInt(dataNode.getAttribute('data-total-pages'), 10) || 1,
        pageParam: dataNode.getAttribute('data-page-param') || 'page',
        totalProducts: parseInt(dataNode.getAttribute('data-total-products'), 10) || 0
      };
    }

    function getPantographKey(item) {
      if (!item) return '';
      // SVG URL is the identity of an individual pantograph. Do not merge by
      // productId because one Shopify product can legitimately contain SVG_1,
      // SVG_2, SVG_3, etc.
      return item.svgUrl;
    }

    function mergePantographs(items) {
      if (!Array.isArray(items) || !items.length) return;

      const existing = new Map();

      allPantographs.forEach(function (item, index) {
        const key = getPantographKey(item);
        if (key) existing.set(key, index);
      });

      items.forEach(function (item) {
        const key = getPantographKey(item);
        if (!key) return;

        if (existing.has(key)) {
          allPantographs[existing.get(key)] = item;
        } else {
          existing.set(key, allPantographs.length);
          allPantographs.push(item);
        }
      });

      catalogIndexReady = false;
    }

    function getThemeValues(value) {
      const values = [];

      function add(raw) {
        if (raw === null || raw === undefined || raw === '') return;

        if (Array.isArray(raw)) {
          raw.forEach(add);
          return;
        }

        if (typeof raw === 'object') {
          if (raw.value !== undefined) {
            add(raw.value);
            return;
          }
          if (raw.label !== undefined) {
            add(raw.label);
            return;
          }
          if (raw.name !== undefined) {
            add(raw.name);
            return;
          }
          Object.values(raw).forEach(add);
          return;
        }

        String(raw)
          .split(/[,;\n|•]+/)
          .map(function (part) { return part.trim(); })
          .filter(Boolean)
          .forEach(function (part) {
            if (!values.some(function (existing) {
              return existing.toLowerCase() === part.toLowerCase();
            })) {
              values.push(part);
            }
          });
      }

      add(value);
      return values;
    }

    function getPantographThemes(item) {
      return getThemeValues(item && item.theme);
    }

    function normalizeSearchText(value) {
      return cleanCatalogText(value)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function buildSearchIndex() {
      if (catalogIndexReady) return;

      searchIndex = allPantographs.map(function (item, index) {
        const title = normalizeSearchText(item.title);
        const theme = normalizeSearchText(getPantographThemes(item).join(' '));
        const designer = normalizeSearchText(item.designer);
        const tags = normalizeSearchText(item.tags);

        return {
          index: index,
          title: title,
          theme: theme,
          designer: designer,
          tags: tags,
          all: [title, theme, designer, tags].filter(Boolean).join(' ')
        };
      });

      catalogIndexReady = true;
    }

    function getSearchScore(indexEntry, query) {
      if (!query) return 0;

      const normalizedQuery = normalizeSearchText(query);
      if (!normalizedQuery) return 0;

      const title = indexEntry.title;
      const queryWords = normalizedQuery.split(/\s+/).filter(Boolean);
      const titleWords = title.split(/\s+/).filter(Boolean);
      const compactTitle = title.replace(/\s+/g, '');
      const compactQuery = normalizedQuery.replace(/\s+/g, '');
      let score = 0;

      if (title === normalizedQuery) score += 1000;
      if (title.indexOf(normalizedQuery) === 0) score += 700;
      if (title.indexOf(' ' + normalizedQuery) !== -1) score += 550;
      if (title.indexOf(normalizedQuery) !== -1) score += 450;
      if (indexEntry.theme === normalizedQuery) score += 380;
      if (indexEntry.theme.indexOf(normalizedQuery) !== -1) score += 280;
      if (indexEntry.designer.indexOf(normalizedQuery) !== -1) score += 160;
      if (indexEntry.tags.indexOf(normalizedQuery) !== -1) score += 120;

      let wordMatches = 0;
      queryWords.forEach(function (word) {
        if (titleWords.some(function (titleWord) { return titleWord === word; })) {
          score += 260;
          wordMatches += 1;
          return;
        }

        if (titleWords.some(function (titleWord) {
          return titleWord.indexOf(word) === 0 || word.indexOf(titleWord) === 0;
        })) {
          score += 150;
          wordMatches += 1;
        }
      });

      if (queryWords.length && wordMatches === queryWords.length) score += 120;
      if (compactTitle === compactQuery) score += 80;

      // Small typo/similarity boost without introducing a heavy fuzzy-search library.
      if (score === 0 && compactQuery.length >= 3) {
        titleWords.forEach(function (word) {
          if (word.length < 3) return;

          let common = 0;
          const shorter = Math.min(word.length, compactQuery.length);
          for (let i = 0; i < shorter; i += 1) {
            if (word.charAt(i) === compactQuery.charAt(i)) common += 1;
          }

          const prefixRatio = common / Math.max(word.length, compactQuery.length);
          if (prefixRatio >= 0.7) score += Math.round(prefixRatio * 80);
        });
      }

      return score;
    }

    function matchesTheme(item, selectedTheme) {
      if (!selectedTheme) return true;
      const wanted = normalizeSearchText(selectedTheme);

      return getPantographThemes(item).some(function (theme) {
        return normalizeSearchText(theme) === wanted;
      });
    }

    function getFilteredPantographs(searchValue, selectedTheme) {
      buildSearchIndex();

      const query = normalizeSearchText(searchValue);
      const results = [];

      searchIndex.forEach(function (entry) {
        const item = allPantographs[entry.index];
        if (!matchesTheme(item, selectedTheme)) return;

        const score = query ? getSearchScore(entry, query) : 0;
        if (query && score <= 0) return;

        results.push({ item: item, index: entry.index, score: score });
      });

      if (query) {
        results.sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return a.index - b.index;
        });
      }

      return results.map(function (result) { return result.item; });
    }

    function createPantographOption(item) {
      const option = document.createElement('option');
      option.value = item.svgUrl;
      option.textContent = item.title;
      option.dataset.title = item.title;
      option.dataset.productUrl = item.productUrl || '';
      option.dataset.productId = item.productId || '';
      option.dataset.svgIndex = item.svgIndex || 1;
      option.dataset.defaultHeight = item.defaultHeight !== null ? item.defaultHeight : '';
      option.dataset.previewWidth = item.previewWidth !== null ? item.previewWidth : '';
      option.dataset.previewHeight = item.previewHeight !== null ? item.previewHeight : '';
      option.dataset.rowGap = item.rowGap !== null ? item.rowGap : '';
      option.dataset.maxHeight = item.maxHeight !== null ? item.maxHeight : '';
      option.dataset.theme = getPantographThemes(item).join(', ');
      option.dataset.designer = item.designer || '';
      option.dataset.precision = item.precision || '';
      option.dataset.offset = item.offset || '';
      option.dataset.backtracking = item.backtracking || '';
      option.dataset.tags = item.tags || '';
      return option;
    }

    function renderPantographOptions() {
      if (!pantographSelect) return;

      const query = pantographSearch ? pantographSearch.value : '';
      const currentValue = selectedSvgUrl || pantographSelect.value;
      const filtered = getFilteredPantographs(query, '');
      const fragment = document.createDocumentFragment();
      const placeholder = document.createElement('option');

      placeholder.value = '';
      placeholder.textContent = catalogComplete
        ? 'Select a pantograph (' + filtered.length + ')'
        : 'Loading pantographs… (' + filtered.length + ')';
      fragment.appendChild(placeholder);

      if (!filtered.length && catalogComplete) {
        const emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = 'No pantographs found';
        emptyOption.disabled = true;
        fragment.appendChild(emptyOption);
      } else {
        filtered.forEach(function (item) {
          fragment.appendChild(createPantographOption(item));
        });
      }

      pantographSelect.innerHTML = '';
      pantographSelect.appendChild(fragment);

      if (currentValue && Array.from(pantographSelect.options).some(function (option) {
        return option.value === currentValue;
      })) {
        pantographSelect.value = currentValue;
      }
    }

    function populateThemeFilter() {
      if (!featuredFilter) return;

      const currentValue = featuredFilter.value;
      const themeMap = new Map();

      allPantographs.forEach(function (item) {
        getPantographThemes(item).forEach(function (theme) {
          const key = normalizeSearchText(theme);
          if (key && !themeMap.has(key)) themeMap.set(key, theme);
        });
      });

      const themes = Array.from(themeMap.values()).sort(function (a, b) {
        return a.localeCompare(b, undefined, { sensitivity: 'base' });
      });

      const fragment = document.createDocumentFragment();
      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = 'Filter by theme';
      fragment.appendChild(allOption);

      themes.forEach(function (theme) {
        const option = document.createElement('option');
        option.value = theme;
        option.textContent = theme;
        fragment.appendChild(option);
      });

      featuredFilter.innerHTML = '';
      featuredFilter.appendChild(fragment);

      if (currentValue && themes.some(function (theme) {
        return normalizeSearchText(theme) === normalizeSearchText(currentValue);
      })) {
        featuredFilter.value = currentValue;
      }
    }

    function getFeaturedItems() {
      return getFilteredPantographs(
        featuredSearch ? featuredSearch.value : '',
        featuredFilter ? featuredFilter.value : ''
      );
    }

    function updateFeaturedStatus(filteredCount) {
      if (!featuredStatus) return;

      if ((featuredSearch && featuredSearch.value.trim()) || (featuredFilter && featuredFilter.value)) {
        featuredStatus.textContent = filteredCount + ' matching pantographs';
        return;
      }

      const total = catalogTotalProducts || allPantographs.length;
      featuredStatus.textContent = catalogComplete
        ? allPantographs.length + ' pantographs available'
        : 'Loading ' + allPantographs.length + ' of ' + total + ' pantographs…';
    }

    function buildCatalogPageUrl(page, pageParam) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', root.getAttribute('data-section-id'));
      url.searchParams.set(pageParam || 'page', String(page));
      return url.toString();
    }

    async function fetchPantographPage(page, pageParam) {
      const response = await fetch(buildCatalogPageUrl(page, pageParam), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Pantograph page ' + page + ' returned ' + response.status);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return readPantographPage(doc);
    }

    async function loadPantographCatalog() {
      const firstPage = readPantographPage(root);

      catalogTotalProducts = firstPage.totalProducts || firstPage.items.length;
      mergePantographs(firstPage.items);
      populateThemeFilter();
      renderPantographOptions();
      resetFeaturedCards();
      updateFeaturedStatus(featuredItems.length);

      if (firstPage.totalPages <= 1) {
        catalogComplete = true;
        populateThemeFilter();
        renderPantographOptions();
        applyFeaturedFilters();
        updateFeaturedControls();
        updateFeaturedStatus(featuredItems.length);
        restorePendingPantograph();
        return;
      }

      try {
        // Sequential loading preserves the collection's exact product order and
        // avoids sending many heavy section-render requests at the same time.
        for (let page = firstPage.currentPage + 1; page <= firstPage.totalPages; page += 1) {
          const pageData = await fetchPantographPage(page, firstPage.pageParam);
          mergePantographs(pageData.items);
          populateThemeFilter();
          renderPantographOptions();
          applyFeaturedFilters();
          updateFeaturedControls();
          updateFeaturedStatus(featuredItems.length);
        }

        catalogComplete = true;
      } catch (error) {
        console.error('Not every pantograph page could be loaded.', error);
        catalogComplete = true;

        if (warning && !selectedPantograph) {
          warning.textContent = 'Some pantographs could not be loaded. Refresh the page and try again.';
          warning.classList.add('is-warning');
        }
      }

      catalogComplete = true;
      populateThemeFilter();
      renderPantographOptions();
      applyFeaturedFilters();
      updateFeaturedControls();
      updateFeaturedStatus(featuredItems.length);
      restorePendingPantograph();
    }

    function restorePendingPantograph() {
      if (!pendingPreviewState || !pendingPreviewState.selectedSvgUrl) {
        return;
      }

      const savedSvgUrl = pendingPreviewState.selectedSvgUrl;
      const pantograph = allPantographs.find(function (item) {
        return item.svgUrl === savedSvgUrl;
      });

      if (!pantograph) {
        pendingPreviewState = null;
        isRestoringPreviewState = false;
        clearSavedPreviewState();
        return;
      }

      // The catalog is now ready, so use the normal selection path. This keeps
      // SVG loading, machine metadata, active cards, and dropdown state in sync.
      loadPantograph(pantograph);
      isRestoringPreviewState = false;
      savePreviewState();
    }

    /**
     * SVG viewBox helpers
     */
    function parseViewBoxValue(viewBox) {
      if (!viewBox) return null;

      const parts = viewBox.trim().split(/[\s,]+/).map(Number);
      if (
        parts.length !== 4 ||
        parts.some(function (part) {
          return !Number.isFinite(part);
        })
      ) {
        return null;
      }

      return {
        x: parts[0],
        y: parts[1],
        width: Math.abs(parts[2]),
        height: Math.abs(parts[3])
      };
    }

    function viewBoxToString(viewBox) {
      return [viewBox.x, viewBox.y, viewBox.width, viewBox.height].join(' ');
    }

    function getElementBBox(element) {
      try {
        if (!element || typeof element.getBBox !== 'function') return null;
        const box = element.getBBox();

        if (
          !box ||
          !Number.isFinite(box.x) ||
          !Number.isFinite(box.y) ||
          !Number.isFinite(box.width) ||
          !Number.isFinite(box.height) ||
          box.width <= 0 ||
          box.height <= 0
        ) {
          return null;
        }

        return box;
      } catch (error) {
        return null;
      }
    }

    function unionBox(current, next) {
      if (!next) return current;
      if (!current) {
        return {
          x: next.x,
          y: next.y,
          width: next.width,
          height: next.height
        };
      }

      const left = Math.min(current.x, next.x);
      const top = Math.min(current.y, next.y);
      const right = Math.max(current.x + current.width, next.x + next.width);
      const bottom = Math.max(current.y + current.height, next.y + next.height);

      return {
        x: left,
        y: top,
        width: right - left,
        height: bottom - top
      };
    }

    function getDrawableBBox(svg) {
      const elements = svg.querySelectorAll('path,line,polyline,polygon,rect,circle,ellipse,use');
      let box = null;

      elements.forEach(function (element) {
        box = unionBox(box, getElementBBox(element));
      });

      return box || getElementBBox(svg);
    }

    function getSideCroppedViewBox(svg, baseViewBox) {
      if (!svg || !baseViewBox || !baseViewBox.width || !baseViewBox.height) {
        return baseViewBox;
      }

      const contentBox = getDrawableBBox(svg);
      if (!contentBox || !contentBox.width || !contentBox.height) {
        return baseViewBox;
      }

      const baseLeft = baseViewBox.x;
      const baseRight = baseViewBox.x + baseViewBox.width;
      const contentLeft = contentBox.x;
      const contentRight = contentBox.x + contentBox.width;
      const padding = baseViewBox.height * 0.025;
      let cropLeft = baseLeft;
      let cropRight = baseRight;

      const blankLeft = Math.max(0, contentLeft - baseLeft);
      const blankRight = Math.max(0, baseRight - contentRight);

      if (blankLeft + blankRight > baseViewBox.width * 0.03) {
        cropLeft = Math.max(baseLeft, contentLeft - padding);
        cropRight = Math.min(baseRight, contentRight + padding);
      }

      let cropWidth = cropRight - cropLeft;
      const maxAspect = getMaxSideCropAspect();

      if (maxAspect > 0 && cropWidth / baseViewBox.height > maxAspect) {
        const maxWidth = baseViewBox.height * maxAspect;
        const centerX = cropLeft + cropWidth / 2;

        cropLeft = centerX - maxWidth / 2;
        cropRight = centerX + maxWidth / 2;

        if (cropLeft < baseLeft) {
          cropRight += baseLeft - cropLeft;
          cropLeft = baseLeft;
        }

        if (cropRight > baseRight) {
          cropLeft -= cropRight - baseRight;
          cropRight = baseRight;
        }

        cropLeft = Math.max(baseLeft, cropLeft);
        cropRight = Math.min(baseRight, cropRight);
        cropWidth = cropRight - cropLeft;
      }

      if (!Number.isFinite(cropWidth) || cropWidth <= 0) return baseViewBox;

      return {
        x: cropLeft,
        y: baseViewBox.y,
        width: cropWidth,
        height: baseViewBox.height
      };
    }

    function applySideCroppedViewBox() {
      if (!svgElement) return;

      const rawViewBox = parseViewBoxValue(svgElement.getAttribute('viewBox'));
      if (!rawViewBox) return;

      const effectiveViewBox = getSideCroppedViewBox(svgElement, rawViewBox);
      svgElement.setAttribute('data-ppt-original-viewbox', viewBoxToString(rawViewBox));
      svgElement.setAttribute('data-ppt-effective-viewbox', viewBoxToString(effectiveViewBox));
      svgElement.setAttribute('viewBox', viewBoxToString(effectiveViewBox));
      svgElement.setAttribute('overflow', 'hidden');
      svgElement.style.overflow = 'hidden';
    }

    /**
     * Product-driven calculations
     */
    function getDefaultDesignHeightInches() {
      return selectedPantograph ? selectedPantograph.defaultHeight : null;
    }

    function getDefaultRowGapInches() {
      return selectedPantograph ? selectedPantograph.rowGap : null;
    }

    function getVisibleScaleFactor() {
      return state.scale / 100;
    }

    function getPreviewSvgWidthInches() {
      return selectedPantograph && Number.isFinite(selectedPantograph.previewWidth)
        ? selectedPantograph.previewWidth
        : 108;
    }

    function getPreviewSvgHeightInches() {
      return selectedPantograph && Number.isFinite(selectedPantograph.previewHeight)
        ? selectedPantograph.previewHeight
        : 108;
    }

    function getRenderPreviewSvgWidthInches() {
      return getPreviewSvgWidthInches() * getVisibleScaleFactor();
    }

    function getRenderPreviewSvgHeightInches() {
      return getPreviewSvgHeightInches() * getVisibleScaleFactor();
    }

    function calculateMachineSetup() {
      const defaultHeight = getDefaultDesignHeightInches();
      const defaultGap = getDefaultRowGapInches();
      const fallbackMax = selectedPantograph && selectedPantograph.maxHeight
        ? selectedPantograph.maxHeight
        : 9;

      const maxRowHeight = numberValue(maxRowInput, fallbackMax);

      const autoCalculatedHeight =
        defaultHeight !== null
          ? defaultHeight * getVisibleScaleFactor()
          : null;

      const selectedHeight =
        Number.isFinite(manualCalculatedHeight) && manualCalculatedHeight > 0
          ? manualCalculatedHeight
          : autoCalculatedHeight;

      const rowGap =
        defaultGap !== null
          ? defaultGap * getVisibleScaleFactor()
          : null;

      const missingSetup =
        defaultHeight === null || defaultGap === null;

      const exceedsMax =
        !missingSetup &&
        Number.isFinite(maxRowHeight) &&
        Number.isFinite(selectedHeight) &&
        selectedHeight > maxRowHeight;

      return {
        defaultHeight: defaultHeight,
        defaultGap: defaultGap,
        maxRowHeight: maxRowHeight,
        calculatedHeight: selectedHeight,
        calculatedGap: rowGap,
        missingSetup: missingSetup,
        exceedsMax: exceedsMax,
        status: missingSetup
          ? 'Missing setup metafields'
          : exceedsMax
            ? 'Too Tall'
            : 'Ready'
      };
    }

    /**
     * Exact quilt-content and overlay metrics
     *
     * The preview image uses object-fit: contain. On layouts where max-height
     * changes the canvas aspect ratio, the actual quilt can have blank margins
     * inside the canvas. All overlay calculations and clipping are therefore
     * based on the quilt's true displayed rectangle, not the outer canvas.
     */
    function getQuiltAspectRatio() {
      if (quiltImg && quiltImg.naturalWidth > 0 && quiltImg.naturalHeight > 0) {
        return quiltImg.naturalWidth / quiltImg.naturalHeight;
      }

      const width = getEffectiveQuiltWidthInches();
      const height = getEffectiveQuiltHeightInches();
      return width > 0 && height > 0 ? width / height : 1;
    }

    function getQuiltContentRect(targetWidth, targetHeight) {
      const safeWidth = Math.max(1, targetWidth || 1);
      const safeHeight = Math.max(1, targetHeight || 1);
      const imageAspect = getQuiltAspectRatio();
      const boxAspect = safeWidth / safeHeight;

      if (!Number.isFinite(imageAspect) || imageAspect <= 0) {
        return { x: 0, y: 0, width: safeWidth, height: safeHeight };
      }

      if (imageAspect > boxAspect) {
        const width = safeWidth;
        const height = width / imageAspect;
        return {
          x: 0,
          y: (safeHeight - height) / 2,
          width: width,
          height: height
        };
      }

      const height = safeHeight;
      const width = height * imageAspect;
      return {
        x: (safeWidth - width) / 2,
        y: 0,
        width: width,
        height: height
      };
    }

    function getOverlayRenderMetrics(targetWidth, targetHeight) {
      if (!svgElement || !targetWidth || !targetHeight) return null;

      const quiltRect = getQuiltContentRect(targetWidth, targetHeight);
      const quiltWidthInches = getEffectiveQuiltWidthInches();
      const quiltHeightInches = getEffectiveQuiltHeightInches();
      const renderSvgWidthInches = getRenderPreviewSvgWidthInches();
      const renderSvgHeightInches = getRenderPreviewSvgHeightInches();

      if (
        !quiltRect.width ||
        !quiltRect.height ||
        !quiltWidthInches ||
        !quiltHeightInches ||
        !renderSvgWidthInches ||
        !renderSvgHeightInches
      ) {
        return null;
      }

      const pixelsPerInchX = quiltRect.width / quiltWidthInches;
      const pixelsPerInchY = quiltRect.height / quiltHeightInches;
      const positionScaleX = quiltRect.width / POSITION_REFERENCE_WIDTH;
      const positionScaleY = quiltRect.height / POSITION_REFERENCE_HEIGHT;
      const strokeScale = ((quiltRect.width + quiltRect.height) / 2) / STROKE_REFERENCE_SIZE;

      return {
        width: renderSvgWidthInches * pixelsPerInchX,
        height: renderSvgHeightInches * pixelsPerInchY,
        centerX: quiltRect.x + quiltRect.width / 2 + state.moveX * positionScaleX,
        centerY: quiltRect.y + quiltRect.height / 2 + state.moveY * positionScaleY,
        strokeWidth: Math.max(0.05, state.strokeWidth * strokeScale),
        quiltRect: quiltRect
      };
    }

    function applyPreviewClip(metrics, canvasWidth, canvasHeight) {
      if (!svgLayer) return;

      if (!metrics || !metrics.quiltRect) {
        svgLayer.style.removeProperty('clip-path');
        svgLayer.style.removeProperty('-webkit-clip-path');
        return;
      }

      const rect = metrics.quiltRect;
      const top = Math.max(0, rect.y);
      const right = Math.max(0, canvasWidth - rect.x - rect.width);
      const bottom = Math.max(0, canvasHeight - rect.y - rect.height);
      const left = Math.max(0, rect.x);
      const inset = 'inset(' + top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px)';

      svgLayer.style.clipPath = inset;
      svgLayer.style.webkitClipPath = inset;
    }

    /**
     * UI updates
     */
    function clampPreviewPan() {
      if (!canvas || state.previewZoom <= 100) {
        state.previewPanX = 0;
        state.previewPanY = 0;
        return;
      }

      const rect = canvas.getBoundingClientRect();
      const zoom = state.previewZoom / 100;
      const maxPanX = (rect.width * (zoom - 1)) / 2;
      const maxPanY = (rect.height * (zoom - 1)) / 2;

      state.previewPanX = Math.max(-maxPanX, Math.min(maxPanX, state.previewPanX));
      state.previewPanY = Math.max(-maxPanY, Math.min(maxPanY, state.previewPanY));
    }

    function applyPreviewZoom() {
      const zoom = state.previewZoom / 100;

      if (state.previewZoom <= 100) {
        state.previewPanX = 0;
        state.previewPanY = 0;
      }

      clampPreviewPan();

      const transform =
        'translate(' +
        state.previewPanX +
        'px, ' +
        state.previewPanY +
        'px) scale(' +
        zoom +
        ')';

      if (quiltImg) {
        quiltImg.style.transform = transform;
        quiltImg.style.transformOrigin = 'center center';
      }

      if (svgLayer) {
        svgLayer.style.transform = transform;
        svgLayer.style.transformOrigin = 'center center';
      }

      if (canvas) {
        canvas.classList.toggle('is-zoomed', state.previewZoom > 100);
        canvas.classList.toggle('is-dragging', isPreviewDragging);
      }

      if (previewZoomOutput) {
        previewZoomOutput.textContent = state.previewZoom + '%';
      }

      setInputValue(previewZoomInput, state.previewZoom);
    }

    function updatePreviewZoom(value) {
      const nextZoom = Math.max(100, Math.min(300, parseInt(value, 10) || 100));
      state.previewZoom = nextZoom;

      if (state.previewZoom <= 100) {
        state.previewPanX = 0;
        state.previewPanY = 0;
      }

      refreshPreview();
    }

    function syncControlPair(rangeInput, numberInput, value) {
      setInputValue(rangeInput, value);
      setInputValue(numberInput, value);
    }

    function updateOutputs() {
      if (scaleOutput) scaleOutput.textContent = state.scale + '%';
      if (positionXOutput) positionXOutput.textContent = state.moveX + ' units';
      if (positionYOutput) positionYOutput.textContent = state.moveY + ' units';
      if (rotationOutput) rotationOutput.textContent = state.rotation + '°';
      if (strokeOutput) strokeOutput.textContent = state.strokeWidth + ' pt';
      if (colorOutput) colorOutput.textContent = state.strokeColor;
      if (opacityOutput) opacityOutput.textContent = state.opacity + '%';

      syncControlPair(scaleInput, scaleNumberInput, state.scale);
      syncControlPair(positionXInput, positionXNumberInput, state.moveX);
      syncControlPair(positionYInput, positionYNumberInput, state.moveY);
      syncControlPair(strokeInput, strokeNumberInput, state.strokeWidth);
      syncControlPair(opacityInput, opacityNumberInput, state.opacity);
      setInputValue(colorInput, state.strokeColor);
      setInputValue(hexInput, state.strokeColor);

      colorPresetButtons.forEach(function (button) {
        button.classList.toggle(
          'is-active',
          button.getAttribute('data-ppt-color-preset').toUpperCase() === state.strokeColor.toUpperCase()
        );
      });

      rotationButtons.forEach(function (button) {
        const degrees = parseInt(button.getAttribute('data-ppt-rotation-option'), 10);
        button.classList.toggle('is-active', degrees === state.rotation);
      });
    }

    function updateButtons() {
      if (downloadBtn) downloadBtn.disabled = !quiltLoaded;
      if (buyBtn) buyBtn.disabled = !selectedProductUrl;
    }

    function updateViewMode() {
      if (!svgLayer || !overlayTab || !originalTab) return;

      if (viewMode === 'original') {
        svgLayer.style.display = 'none';
        overlayTab.classList.remove('ppt-tab--active');
        originalTab.classList.add('ppt-tab--active');
      } else {
        svgLayer.style.display = '';
        overlayTab.classList.add('ppt-tab--active');
        originalTab.classList.remove('ppt-tab--active');
      }
    }

    function updateMachineGuide() {
      const setup = calculateMachineSetup();

      if (resultScale) resultScale.textContent = state.scale + '%';
      if (resultHeight) {resultHeight.value = setup.calculatedHeight !== null? setup.calculatedHeight: '';}
      if (resultGap) resultGap.textContent = formatInches(setup.calculatedGap);
      if (resultCheck) resultCheck.textContent = setup.status;
      if (setupDefaultHeight) setupDefaultHeight.textContent = formatInches(setup.defaultHeight);
      if (setupDefaultGap) setupDefaultGap.textContent = formatInches(setup.defaultGap);
      if (setupTheme) setupTheme.textContent = selectedPantograph && selectedPantograph.theme ? selectedPantograph.theme : 'Not set';
      if (setupDesigner) setupDesigner.textContent = selectedPantograph && selectedPantograph.designer ? selectedPantograph.designer : 'Not set';
      if (setupPrecision) setupPrecision.textContent = selectedPantograph && selectedPantograph.precision ? selectedPantograph.precision : 'Not set';
      if (setupOffset) setupOffset.textContent = selectedPantograph && selectedPantograph.offset ? selectedPantograph.offset : 'Not set';
      if (setupBacktracking) setupBacktracking.textContent = selectedPantograph && selectedPantograph.backtracking ? selectedPantograph.backtracking : 'Not set';

      if (!warning) return;

      if (setup.missingSetup) {
        warning.textContent = 'Machine setup metafields are missing for this pantograph.';
        warning.classList.add('is-warning');
      } else if (setup.exceedsMax) {
        warning.textContent = 'Suggested design height exceeds your maximum row height. Reduce scale or increase maximum row height.';
        warning.classList.add('is-warning');
      } else {
        warning.textContent = 'Setup looks good.';
        warning.classList.remove('is-warning');
      }
    }

    function updateSidebarHeight() {
      if (!previewColumn || !controlsColumn) return;

      if (window.matchMedia('(max-width: 1100px)').matches) {
        root.style.removeProperty('--ppt-preview-panel-height');
        return;
      }

      const height = previewColumn.offsetHeight;
      if (height > 0) {
        root.style.setProperty('--ppt-preview-panel-height', height + 'px');
      }
    }

    function applyStrokeStylesToElement(scope, strokeWidth) {
      if (!scope) return;

      const targets = scope.querySelectorAll('path,line,polyline,polygon,rect,circle,ellipse,use,g');
      targets.forEach(function (element) {
        element.removeAttribute('style');
        element.setAttribute('stroke', state.strokeColor);
        element.setAttribute('stroke-width', strokeWidth);
        element.setAttribute('fill', 'none');
        element.setAttribute('stroke-linecap', 'round');
        element.setAttribute('stroke-linejoin', 'round');
        element.setAttribute('vector-effect', 'non-scaling-stroke');
        element.style.stroke = state.strokeColor;
        element.style.strokeWidth = strokeWidth + 'px';
        element.style.fill = 'none';
        element.style.vectorEffect = 'non-scaling-stroke';
      });
    }

    function applySvgStyles(metrics) {
      if (!svgElement || !svgLayer) return;

      svgLayer.style.opacity = state.opacity / 100;
      applyStrokeStylesToElement(
        svgElement,
        metrics && Number.isFinite(metrics.strokeWidth) ? metrics.strokeWidth : state.strokeWidth
      );
    }

    function applySvgTransform() {
      if (!svgElement || !canvas) return null;

      const rect = canvas.getBoundingClientRect();
      const metrics = getOverlayRenderMetrics(rect.width, rect.height);
      if (!metrics) return null;

      if (svgLayer) {
        svgLayer.style.overflow = 'hidden';
      }

      applyPreviewClip(metrics, rect.width, rect.height);

      svgElement.style.width = metrics.width + 'px';
      svgElement.style.height = metrics.height + 'px';
      svgElement.style.left = metrics.centerX + 'px';
      svgElement.style.top = metrics.centerY + 'px';
      svgElement.style.position = 'absolute';
      svgElement.style.transformOrigin = 'center center';
      svgElement.style.maxWidth = 'none';
      svgElement.style.maxHeight = 'none';
      svgElement.style.overflow = 'hidden';
      svgElement.style.display = 'block';
      svgElement.style.transform = 'translate(-50%, -50%) rotate(' + state.rotation + 'deg)';

      return metrics;
    }

    function refreshSettingsBox() {
      if (settingsTextarea) {
        settingsTextarea.value = getSettingsText();
      }
    }

    function refreshPreview() {
      applyPreviewZoom();
      updateOutputs();
      const metrics = applySvgTransform();
      applySvgStyles(metrics);
      updateViewMode();
      updateMachineGuide();
      updateButtons();
      refreshSettingsBox();
      updateSidebarHeight();
      updateMobileStickyLayout();
      savePreviewState();
    }

    /**
     * Quilt upload
     */
    function handleQuiltFile(file) {
      if (!file || !file.type || !file.type.startsWith('image/')) {
        alert('Please upload a JPG or PNG quilt photo.');
        return;
      }

      const reader = new FileReader();

      reader.onload = function (event) {
        quiltImg.onload = function () {
          if (quiltImg.naturalWidth && quiltImg.naturalHeight) {
            canvas.style.aspectRatio = quiltImg.naturalWidth + ' / ' + quiltImg.naturalHeight;
          }

          quiltImg.classList.add('is-visible');

          if (emptyState) {
            emptyState.style.display = 'none';
          }

          quiltLoaded = true;

          if (uploadBox) {
            uploadBox.classList.add('is-loaded');
            const title = uploadBox.querySelector('.ppt-upload-title');
            const small = uploadBox.querySelector('small');
            if (title) title.textContent = 'Photo Uploaded';
            if (small) small.textContent = file.name;
          }

          refreshPreview();
        };

        quiltImg.src = event.target.result;
      };

      reader.readAsDataURL(file);
    }

    /**
     * SVG loading and selection
     */
    function cleanSvgText(rawText) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(rawText, 'image/svg+xml');
      const svg = doc.querySelector('svg');

      if (!svg) {
        throw new Error('Invalid SVG');
      }

      svg.querySelectorAll('script, foreignObject').forEach(function (element) {
        element.remove();
      });

      const widthAttr = parseFloat(svg.getAttribute('width'));
      const heightAttr = parseFloat(svg.getAttribute('height'));

      if (!svg.getAttribute('viewBox')) {
        if (
          Number.isFinite(widthAttr) &&
          widthAttr > 0 &&
          Number.isFinite(heightAttr) &&
          heightAttr > 0
        ) {
          svg.setAttribute('viewBox', '0 0 ' + widthAttr + ' ' + heightAttr);
        } else {
          svg.setAttribute('viewBox', '0 0 100 100');
        }
      }

      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('overflow', 'hidden');

      return new XMLSerializer().serializeToString(svg);
    }

    function renderSVG(rawText) {
      const svgText = cleanSvgText(rawText);
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgText, 'image/svg+xml');
      const svg = doc.querySelector('svg');

      if (!svgLayer) return;

      svgLayer.innerHTML = '';
      svgLayer.appendChild(svg);
      svgElement = svg;
      applySideCroppedViewBox();
      svgLoaded = true;
      viewMode = 'overlay';
      refreshPreview();
    }

    function updateProductActiveState(svgUrl) {
      root.querySelectorAll('.ppt-product-card[data-svg-url]').forEach(function (card) {
        card.classList.toggle('is-active', !!svgUrl && card.getAttribute('data-svg-url') === svgUrl);
      });
    }

    function syncDropdownBySvg(svgUrl) {
      if (!pantographSelect) return;

      const matchExists = Array.from(pantographSelect.options).some(function (option) {
        return option.value === svgUrl;
      });

      if (matchExists) pantographSelect.value = svgUrl;
    }

    function setMaxRowFromProduct(pantograph) {
      if (!maxRowInput || !pantograph || !pantograph.maxHeight) return;

      const optionValue = String(Math.round(pantograph.maxHeight));
      const matchingOption = Array.from(maxRowInput.options).find(function (option) {
        return option.value === optionValue;
      });

      if (matchingOption) {
        maxRowInput.value = optionValue;
      }
    }

    function loadPantograph(pantograph) {
      if (!pantograph || !pantograph.svgUrl) return;

      selectedPantograph = pantograph;
      selectedSvgUrl = pantograph.svgUrl;
      selectedProductTitle = pantograph.title || '';
      selectedProductUrl = pantograph.productUrl || '';
      setMaxRowFromProduct(pantograph);
      updateButtons();

      fetch(pantograph.svgUrl, { cache: 'no-cache' })
        .then(function (response) {
          if (!response.ok) throw new Error('SVG URL failed');
          return response.text();
        })
        .then(function (text) {
          renderSVG(text);
          syncDropdownBySvg(pantograph.svgUrl);
          updateProductActiveState(pantograph.svgUrl);
          scrollToSelectedPantograph(true);
        })
        .catch(function () {
          alert('SVG could not be loaded. Please check the product metafield URL.');
          refreshPreview();
        });
    }

    function loadPantographBySvg(svgUrl) {
      const pantograph = allPantographs.find(function (item) {
        return item.svgUrl === svgUrl;
      });

      loadPantograph(pantograph);
    }

    function clearPantograph() {
      selectedPantograph = null;
      selectedProductUrl = '';
      selectedProductTitle = '';
      selectedSvgUrl = '';
      manualCalculatedHeight = null;
      svgElement = null;
      svgLoaded = false;

      if (svgLayer) {
        svgLayer.innerHTML = '';
        svgLayer.style.removeProperty('clip-path');
        svgLayer.style.removeProperty('-webkit-clip-path');
      }

      updateProductActiveState('');
      refreshPreview();
    }

    /**
     * Featured pantograph carousel
     */
    function createFeaturedCard(item) {
      const card = document.createElement('div');
      card.className = 'ppt-product-card';
      card.setAttribute('data-svg-url', item.svgUrl);

      const imageWrap = document.createElement('div');
      imageWrap.className = 'ppt-product-image';

      if (item.imageUrl) {
        const image = document.createElement('img');
        image.src = item.imageUrl;
        image.alt = item.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        imageWrap.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'ppt-product-placeholder';
        placeholder.textContent = 'SVG';
        imageWrap.appendChild(placeholder);
      }

      const title = document.createElement('h4');
      title.textContent = item.title;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ppt-use-preview';
      button.textContent = 'Use In Preview';
      button.setAttribute('data-svg-url', item.svgUrl);
      button.setAttribute('data-title', item.title);
      button.setAttribute('data-product-url', item.productUrl || '');
      button.setAttribute('data-product-id', item.productId || '');

      card.appendChild(imageWrap);
      card.appendChild(title);
      card.appendChild(button);

      if (item.svgUrl === selectedSvgUrl) card.classList.add('is-active');
      return card;
    }

    function renderFeaturedItems(items) {
      if (!featuredTrack) return;

      featuredItems = Array.isArray(items) ? items.slice() : [];
      featuredRenderedCount = 0;
      featuredTrack.innerHTML = '';
      appendFeaturedBatch();
      updateFeaturedStatus(featuredItems.length);
    }

    function appendFeaturedBatch() {
      if (!featuredTrack || featuredRenderedCount >= featuredItems.length) return;

      const end = Math.min(featuredRenderedCount + FEATURED_BATCH_SIZE, featuredItems.length);
      const fragment = document.createDocumentFragment();

      for (let index = featuredRenderedCount; index < end; index += 1) {
        fragment.appendChild(createFeaturedCard(featuredItems[index]));
      }

      featuredTrack.appendChild(fragment);
      featuredRenderedCount = end;
      updateFeaturedControls();
      updateFeaturedStatus(featuredItems.length);
    }

    function resetFeaturedCards() {
      renderFeaturedItems(getFeaturedItems());
    }

    function isFeaturedNearEnd() {
      if (!featuredTrack) return false;
      return featuredTrack.scrollLeft + featuredTrack.clientWidth >= featuredTrack.scrollWidth - featuredTrack.clientWidth * 0.6;
    }

    function updateFeaturedControls() {
      if (!featuredTrack) return;

      const maxScroll = Math.max(0, featuredTrack.scrollWidth - featuredTrack.clientWidth);
      const atStart = featuredTrack.scrollLeft <= 2;
      const atEnd = featuredTrack.scrollLeft >= maxScroll - 2;
      const noMoreRendered = featuredRenderedCount >= featuredItems.length;

      if (featuredPrev) featuredPrev.disabled = atStart;
      if (featuredNext) featuredNext.disabled = atEnd && noMoreRendered;
    }

    function scrollFeatured(direction) {
      if (!featuredTrack) return;

      if (direction > 0 && isFeaturedNearEnd()) appendFeaturedBatch();

      const distance = Math.max(240, featuredTrack.clientWidth * 0.85) * direction;
      featuredTrack.scrollBy({ left: distance, behavior: 'smooth' });
      window.setTimeout(updateFeaturedControls, 350);
    }

    function applyFeaturedFilters() {
      const filtered = getFeaturedItems();
      renderFeaturedItems(filtered);

      if (selectedSvgUrl) {
        window.requestAnimationFrame(function () {
          scrollToSelectedPantograph(false);
        });
      }
    }

    function debounceFeaturedFilters() {
      if (featuredSearchTimer) window.clearTimeout(featuredSearchTimer);
      featuredSearchTimer = window.setTimeout(applyFeaturedFilters, 90);
    }

    function scrollToSelectedPantograph(smooth) {
      if (!featuredTrack || !selectedSvgUrl) return;

      const targetIndex = featuredItems.findIndex(function (item) {
        return item.svgUrl === selectedSvgUrl;
      });

      if (targetIndex === -1) return;

      while (featuredRenderedCount <= targetIndex && featuredRenderedCount < featuredItems.length) {
        appendFeaturedBatch();
      }

      const cards = featuredTrack.querySelectorAll('.ppt-product-card[data-svg-url]');
      const card = Array.from(cards).find(function (candidate) {
        return candidate.getAttribute('data-svg-url') === selectedSvgUrl;
      });

      if (!card) return;

      updateProductActiveState(selectedSvgUrl);
      card.scrollIntoView({
        behavior: smooth ? 'smooth' : 'auto',
        block: 'nearest',
        inline: 'center'
      });
    }

    /**
     * Controls
     */
    function updateScale(value) {
      const meta = getRangeMeta(scaleInput, 1, 200, 1);
      state.scale = clamp(value, meta.min, meta.max);
      refreshPreview();
    }

    function updateNumericControl(name, value) {
      const map = {
        strokeWidth: { range: strokeInput, fallbackMin: 0.25, fallbackMax: 8 },
        opacity: { range: opacityInput, fallbackMin: 10, fallbackMax: 100 },
        moveX: { range: positionXInput, fallbackMin: -300, fallbackMax: 300 },
        moveY: { range: positionYInput, fallbackMin: -300, fallbackMax: 300 }
      };

      const config = map[name];
      if (!config) return;

      const meta = getRangeMeta(config.range, config.fallbackMin, config.fallbackMax, 1);
      state[name] = clamp(value, meta.min, meta.max);
      refreshPreview();
    }

    function updateColor(value) {
      const hex = sanitizeHex(value);
      if (!hex) return;
      state.strokeColor = hex;
      refreshPreview();
    }

    function resetView() {
      Object.assign(state, defaultState);
      viewMode = 'overlay';
      refreshPreview();
    }

    function resetForPantographChange() {
      const keepStrokeWidth = state.strokeWidth;
      const keepStrokeColor = state.strokeColor;

      Object.assign(state, defaultState);
      state.strokeWidth = keepStrokeWidth;
      state.strokeColor = keepStrokeColor;

      manualCalculatedHeight = null;
    }

    /**
     * Settings text
     */
    function getSettingsText() {
      const setup = calculateMachineSetup();

      const lines = [
        'Pantograph Preview Settings',
        '---------------------------',
        'Pantograph: ' + (selectedProductTitle || 'Not selected'),
        '',
        'Calculated Row Height: ' + formatInches(setup.calculatedHeight),
        'Calculated Row Gap: ' + formatInches(setup.calculatedGap)
      ];

      if (state.rotation !== 0) {
        lines.push('Rotation: ' + state.rotation + '°');

        if (state.rotation === 90 || state.rotation === 180 || state.rotation === 270) {
          lines.push(
            '',
            'Note: to achieve this rotation of the pantograph you need to load your quilt sideways.'
          );
        }
      }

      return lines.join('\n');
    }

    function copySettings() {
      const text = getSettingsText();

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () {
          if (!copySettingsBtn) return;
          const oldText = copySettingsBtn.textContent;
          copySettingsBtn.textContent = 'Copied!';
          setTimeout(function () {
            copySettingsBtn.textContent = oldText;
          }, 1200);
        });
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      alert('Settings copied.');
    }

    function downloadSettings() {
      const text = getSettingsText();
      const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = 'pantograph-preview-settings.txt';
      link.click();

      window.setTimeout(function () {
        URL.revokeObjectURL(url);
      }, 0);
    }

    /**
     * Exact export
     *
     * The same normalized metrics function is used for both live preview and
     * natural-resolution export. No live DOM pixel values are copied, so the
     * result cannot drift when the responsive layout changes.
     */
    function createExportSvg(exportWidth, exportHeight) {
      const metrics = getOverlayRenderMetrics(exportWidth, exportHeight);
      const exportSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      exportSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      exportSvg.setAttribute('width', exportWidth);
      exportSvg.setAttribute('height', exportHeight);
      exportSvg.setAttribute('viewBox', '0 0 ' + exportWidth + ' ' + exportHeight);
      exportSvg.setAttribute('overflow', 'hidden');

      if (!svgElement || !metrics) return exportSvg;

      const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      group.setAttribute(
        'transform',
        'translate(' +
          metrics.centerX +
          ' ' +
          metrics.centerY +
          ') rotate(' +
          state.rotation +
          ') translate(' +
          -metrics.width / 2 +
          ' ' +
          -metrics.height / 2 +
          ')'
      );

      const clone = svgElement.cloneNode(true);
      clone.removeAttribute('style');
      clone.removeAttribute('width');
      clone.removeAttribute('height');
      clone.setAttribute('x', 0);
      clone.setAttribute('y', 0);
      clone.setAttribute('width', metrics.width);
      clone.setAttribute('height', metrics.height);
      clone.setAttribute('preserveAspectRatio', svgElement.getAttribute('preserveAspectRatio') || 'xMidYMid meet');
      clone.setAttribute('overflow', 'hidden');

      applyStrokeStylesToElement(clone, metrics.strokeWidth);
      group.appendChild(clone);
      exportSvg.appendChild(group);

      return exportSvg;
    }

    function downloadPreview() {
      if (!quiltLoaded) {
        alert('Please upload a quilt photo first.');
        return;
      }

      if (!svgLoaded || !svgElement) {
        alert('Please select a pantograph design first.');
        return;
      }

      const exportCanvas = document.createElement('canvas');
      exportCanvas.width = quiltImg.naturalWidth;
      exportCanvas.height = quiltImg.naturalHeight;

      const context = exportCanvas.getContext('2d');
      context.clearRect(0, 0, exportCanvas.width, exportCanvas.height);
      context.drawImage(quiltImg, 0, 0, exportCanvas.width, exportCanvas.height);

      if (viewMode === 'original') {
        const originalLink = document.createElement('a');
        originalLink.download = 'pantograph-preview.png';
        originalLink.href = exportCanvas.toDataURL('image/png');
        originalLink.click();
        return;
      }

      const svgExport = createExportSvg(exportCanvas.width, exportCanvas.height);
      const svgData = new XMLSerializer().serializeToString(svgExport);
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);
      const svgImage = new Image();

      svgImage.onload = function () {
        context.globalAlpha = state.opacity / 100;
        context.drawImage(svgImage, 0, 0, exportCanvas.width, exportCanvas.height);
        context.globalAlpha = 1;
        URL.revokeObjectURL(svgUrl);

        const link = document.createElement('a');
        link.download = 'pantograph-preview.png';
        link.href = exportCanvas.toDataURL('image/png');
        link.click();
      };

      svgImage.onerror = function () {
        URL.revokeObjectURL(svgUrl);
        alert('Could not render SVG into the download image.');
      };

      svgImage.src = svgUrl;
    }

    /**
     * Mobile sticky layout
     */
    function getActiveHeaderHeight() {
      const selectors = [
        '#shopify-section-header',
        'sticky-header',
        '.shopify-section-header-sticky',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ];

      let headerBottom = 0;

      selectors.forEach(function (selector) {
        const header = document.querySelector(selector);
        if (!header || root.contains(header)) return;

        const rect = header.getBoundingClientRect();
        const style = window.getComputedStyle(header);
        const isActiveHeader =
          rect.height > 0 &&
          rect.bottom > 0 &&
          rect.top <= 2 &&
          (style.position === 'sticky' || style.position === 'fixed' || rect.top === 0);

        if (isActiveHeader) {
          headerBottom = Math.max(headerBottom, rect.bottom);
        }
      });

      return Math.round(Math.max(0, headerBottom));
    }

    function updateMobileStickyLayout() {
      if (!stickyPreviewColumn || !mobileControlsColumn) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (!isMobile) {
        root.style.removeProperty('--ppt-mobile-sticky-top');
        root.style.removeProperty('--ppt-mobile-controls-height');
        stickyPreviewColumn.style.removeProperty('top');
        mobileControlsColumn.style.removeProperty('max-height');
        mobileControlsColumn.style.removeProperty('overflow-y');
        return;
      }

      const headerHeight = getActiveHeaderHeight();
      root.style.setProperty('--ppt-mobile-sticky-top', headerHeight + 'px');

      window.requestAnimationFrame(function () {
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const previewHeight = stickyPreviewColumn.getBoundingClientRect().height;
        const controlsHeight = Math.max(260, viewportHeight - headerHeight - previewHeight - 12);
        root.style.setProperty('--ppt-mobile-controls-height', controlsHeight + 'px');
      });
    }

    /**
     * Events
     */
    if (canvas) {
      canvas.addEventListener('pointerdown', function (event) {
        if (state.previewZoom <= 100) return;

        isPreviewDragging = true;
        previewDragStartX = event.clientX;
        previewDragStartY = event.clientY;
        previewDragStartPanX = state.previewPanX;
        previewDragStartPanY = state.previewPanY;
        canvas.classList.add('is-dragging');

        if (canvas.setPointerCapture) {
          canvas.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
      });

      canvas.addEventListener('pointermove', function (event) {
        if (!isPreviewDragging || state.previewZoom <= 100) return;

        state.previewPanX = previewDragStartPanX + event.clientX - previewDragStartX;
        state.previewPanY = previewDragStartPanY + event.clientY - previewDragStartY;
        clampPreviewPan();
        applyPreviewZoom();
        event.preventDefault();
      });

      canvas.addEventListener('pointerup', function (event) {
        isPreviewDragging = false;
        canvas.classList.remove('is-dragging');

        if (canvas.releasePointerCapture) {
          canvas.releasePointerCapture(event.pointerId);
        }
      });

      canvas.addEventListener('pointercancel', function () {
        isPreviewDragging = false;
        canvas.classList.remove('is-dragging');
      });
    }

    if (previewZoomMinus) {
      previewZoomMinus.addEventListener('click', function () {
        updatePreviewZoom(state.previewZoom - 10);
      });
    }

    if (previewZoomPlus) {
      previewZoomPlus.addEventListener('click', function () {
        updatePreviewZoom(state.previewZoom + 10);
      });
    }

    if (previewZoomInput) {
      previewZoomInput.addEventListener('input', function () {
        updatePreviewZoom(previewZoomInput.value);
      });
    }

    colorPresetButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        updateColor(button.getAttribute('data-ppt-color-preset'));
      });
    });

    if (uploadBox && quiltInput) {
      uploadBox.addEventListener('click', function () {
        quiltInput.click();
      });

      uploadBox.addEventListener('dragover', function (event) {
        event.preventDefault();
        uploadBox.classList.add('is-dragover');
      });

      uploadBox.addEventListener('dragleave', function () {
        uploadBox.classList.remove('is-dragover');
      });

      uploadBox.addEventListener('drop', function (event) {
        event.preventDefault();
        uploadBox.classList.remove('is-dragover');
        const file = event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) handleQuiltFile(file);
      });
    }

    if (quiltInput) {
      quiltInput.addEventListener('change', function () {
        const file = quiltInput.files && quiltInput.files[0];
        if (file) handleQuiltFile(file);
      });
    }

    if (pantographSearch) {
      pantographSearch.addEventListener('input', renderPantographOptions);
    }

    if (featuredSearch) {
      featuredSearch.addEventListener('input', debounceFeaturedFilters);
    }

    if (featuredFilter) {
      featuredFilter.addEventListener('change', applyFeaturedFilters);
    }

    if (pantographSelect) {
      pantographSelect.addEventListener('change', function () {
        if (!pantographSelect.value) {
          clearPantograph();
          return;
        }

        resetForPantographChange();
        loadPantographBySvg(pantographSelect.value);
      });
    }

    // Event delegation keeps every dynamically appended featured card working.
    root.addEventListener('click', function (event) {
      const button = event.target.closest('[data-svg-url]');
      if (!button || !root.contains(button) || button.disabled) return;

      const svgUrl = button.getAttribute('data-svg-url');
      if (!svgUrl) return;

      resetForPantographChange();
      loadPantographBySvg(svgUrl);
    });

    if (scaleInput) {
      scaleInput.addEventListener('input', function () {
        updateScale(scaleInput.value);
      });
    }

    if (scaleNumberInput) {
      scaleNumberInput.addEventListener('input', function () {
        updateScale(scaleNumberInput.value);
      });
    }

    if (positionXInput) {
      positionXInput.addEventListener('input', function () {
        updateNumericControl('moveX', positionXInput.value);
      });
    }

    if (positionXNumberInput) {
      positionXNumberInput.addEventListener('input', function () {
        updateNumericControl('moveX', positionXNumberInput.value);
      });
    }

    if (positionYInput) {
      positionYInput.addEventListener('input', function () {
        updateNumericControl('moveY', positionYInput.value);
      });
    }

    if (positionYNumberInput) {
      positionYNumberInput.addEventListener('input', function () {
        updateNumericControl('moveY', positionYNumberInput.value);
      });
    }

    if (strokeInput) {
      strokeInput.addEventListener('input', function () {
        updateNumericControl('strokeWidth', strokeInput.value);
      });
    }

    if (strokeNumberInput) {
      strokeNumberInput.addEventListener('input', function () {
        updateNumericControl('strokeWidth', strokeNumberInput.value);
      });
    }

    if (opacityInput) {
      opacityInput.addEventListener('input', function () {
        updateNumericControl('opacity', opacityInput.value);
      });
    }

    if (opacityNumberInput) {
      opacityNumberInput.addEventListener('input', function () {
        updateNumericControl('opacity', opacityNumberInput.value);
      });
    }

    if (colorInput) {
      colorInput.addEventListener('input', function () {
        updateColor(colorInput.value);
      });
    }

    if (hexInput) {
      hexInput.addEventListener('input', function () {
        updateColor(hexInput.value);
      });
    }

    rotationButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.rotation = parseInt(button.getAttribute('data-ppt-rotation-option'), 10) || 0;
        refreshPreview();
      });
    });

    [quiltWidthInput, quiltHeightInput, maxRowInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', refreshPreview);
      input.addEventListener('change', refreshPreview);
    });

    if (resultHeight) {
      resultHeight.addEventListener('input', function () {
        const value = parseFloat(resultHeight.value);

        if (Number.isFinite(value) && value > 0) {
          manualCalculatedHeight = value;
          updateMachineGuide();
        }
      });
    }

    if (overlayTab) {
      overlayTab.addEventListener('click', function () {
        viewMode = 'overlay';
        refreshPreview();
      });
    }

    if (originalTab) {
      originalTab.addEventListener('click', function () {
        viewMode = 'original';
        refreshPreview();
      });
    }

    resetViewButtons.forEach(function (button) {
      button.addEventListener('click', resetView);
    });

    if (downloadBtn) downloadBtn.addEventListener('click', downloadPreview);

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (!selectedProductUrl) {
          alert('Please select a pantograph design first.');
          return;
        }

        savePreviewState();
        window.location.href = selectedProductUrl;
      });
    }

    if (copySettingsBtn) copySettingsBtn.addEventListener('click', copySettings);
    if (downloadSettingsBtn) downloadSettingsBtn.addEventListener('click', downloadSettings);

    if (featuredPrev) {
      featuredPrev.addEventListener('click', function () {
        scrollFeatured(-1);
      });
    }

    if (featuredNext) {
      featuredNext.addEventListener('click', function () {
        scrollFeatured(1);
      });
    }

    if (featuredTrack) {
      featuredTrack.addEventListener('scroll', function () {
        if (isFeaturedNearEnd()) appendFeaturedBatch();
        updateFeaturedControls();
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      refreshPreview();
      updateFeaturedControls();
      updateMobileStickyLayout();
    });

    window.addEventListener('scroll', updateMobileStickyLayout, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateMobileStickyLayout);
    }

    /**
     * Initial render
     */
    restorePreviewState();
    updateOutputs();
    updateViewMode();
    updateMachineGuide();
    updateButtons();
    refreshSettingsBox();
    updateSidebarHeight();
    updateMobileStickyLayout();
    updateFeaturedControls();
    loadPantographCatalog();
  });
})();